// --- CONEXIÓN DINÁMICA CON EL EDITOR DE SHOPIFY ---
const textCat1 = (window.FungiProConfig && window.FungiProConfig.textCat1) ? window.FungiProConfig.textCat1 : "¿Qué estás <i>sintiendo?</i>";
const textCat2 = (window.FungiProConfig && window.FungiProConfig.textCat2) ? window.FungiProConfig.textCat2 : "¿Qué quieres <i>lograr?</i>";

let activeProds = new Set();
let removedProds = new Set(); 
let currentCat = ''; 
let currentActiveDiscountCode = null; 
let pendingCartItems = [];
let currentTotalCents = 0; 

// --- HELPER DE ANALYTICS AVANZADO (GA4) ---
function f_track(eventName, props = {}) {
  if (typeof gtag === 'function') {
    // 1. Evento personalizado para embudos específicos del quiz
    gtag('event', eventName, { 
      event_category: 'fungi_quiz',
      event_label: currentCat || 'inicio',
      ...props 
    });

    // 2. Mapeo a eventos E-commerce Estándar de GA4
    if (eventName === 'product_added_to_cart') {
      gtag('event', 'add_to_cart', {
        currency: 'CLP',
        value: props.total_value / 100, // GA4 lee moneda estándar, no centavos
        items: props.items_array || []
      });
    }
    
    if (eventName === 'quiz_completed') {
      gtag('event', 'generate_lead', {
        quiz_path: currentCat,
        sintomas_seleccionados: props.selected_options
      });
    }
  }
}

// Tracking pasivo de interacciones (Mapa de calor de clics para GA4)
document.addEventListener('click', (e) => {
  const trackable = e.target.closest('.f-path-card, .f-opt-card');
  if (trackable && typeof gtag === 'function') {
    const actionName = trackable.innerText.split('\n')[0].trim().substring(0, 40);
    gtag('event', 'quiz_interaction', {
      element_type: trackable.classList.contains('f-path-card') ? 'camino' : 'opcion',
      element_text: actionName
    });
  }
});

const discountConfig = {
  3: { code: 'FUNGI10', percent: 0.10, text: '10% de descuento — perfecto para 3 extractos' },
  4: { code: 'FUNGI15', percent: 0.15, text: '15% de descuento — gran ahorro con 4 extractos' },
  5: { code: 'FUNGI20', percent: 0.20, text: '20% de descuento — máximo ahorro con 5 extractos' }
};

function formatMoney(cents) { return '$' + (cents / 100).toLocaleString('es-CL', { maximumFractionDigits: 0 }); }

// --- CACHÉ INTELIGENTE CON TTL (TIME-TO-LIVE) ---
let saveTimeout;
function f_saveState() {
  clearTimeout(saveTimeout);
  saveTimeout = setTimeout(() => {
    try { 
      const selectedTitles = Array.from(document.querySelectorAll('.f-opcion-item.selected')).map(el => el.querySelector('.f-opt-title').innerText.trim());
      const activeStep = document.querySelector('.fungi-step.active') ? document.querySelector('.fungi-step.active').id : 'f-step-1';
      const removedHandles = Array.from(removedProds); 
      
      const now = new Date().getTime();
      const ttl = 5 * 60 * 1000; // 5 minutos de vida en milisegundos
      
      localStorage.setItem('fungi_pro_state', JSON.stringify({ 
        step: activeStep, 
        cat: currentCat, 
        selected: selectedTitles,
        removed: removedHandles,
        expiry: now + ttl // Se guarda la fecha de caducidad
      }));
    } catch(e) {
      console.warn('FungiQuiz: Navegador bloqueó guardado de estado.', e);
    }
  }, 300);
}

function f_loadState() {
  const saved = localStorage.getItem('fungi_pro_state');
  if (saved) {
    try {
      const state = JSON.parse(saved);
      const now = new Date().getTime();
      
      // Si ya pasaron los 5 minutos, borra la caché y empieza de cero
      if (state.expiry && now > state.expiry) {
        localStorage.removeItem('fungi_pro_state');
        f_track('quiz_started', { type: 'fresh_start' });
        return; 
      }
      
      if (state.removed && state.removed.length > 0) {
        state.removed.forEach(h => removedProds.add(h));
      }

      if (state.selected && state.selected.length > 0) {
        document.querySelectorAll('.f-opcion-item').forEach(card => {
          const title = card.querySelector('.f-opt-title').innerText.trim();
          if (state.selected.includes(title)) card.classList.add('selected');
        });
        f_updateBar();
      }
      if (state.step === 'f-step-2' && state.cat) f_goToStep2(state.cat, true);
      else if (state.step === 'f-step-3' && state.cat) {
        currentCat = state.cat; 
        document.querySelectorAll('.f-opcion-item').forEach(card => card.style.display = card.getAttribute('data-cat') === state.cat ? 'block' : 'none');
        f_goToStep3(true);
      }
      f_track('quiz_started', { type: 'restored_session' });
    } catch(e) {}
  } else {
    f_track('quiz_started', { type: 'fresh_start' });
  }
}

function f_goToStep1(isLoad = false) {
  document.querySelectorAll('.fungi-step').forEach(el => el.classList.remove('active'));
  document.getElementById('f-step-1').classList.add('active');
  document.querySelectorAll('.f-opcion-item').forEach(el => el.classList.remove('selected'));
  currentCat = '';
  removedProds.clear(); 
  f_updateBar();
  if(!isLoad) f_saveState();
}

function f_goToStep2(categoria, isLoad = false) {
  currentCat = categoria;
  document.querySelectorAll('.fungi-step').forEach(el => el.classList.remove('active'));
  document.getElementById('f-step-2').classList.add('active');
  
  // Imprime el texto dinámico que viene del Theme Editor
  document.getElementById('f-dynamic-title').innerHTML = categoria === 'cat1' ? textCat1 : textCat2;
  
  document.querySelectorAll('.f-opcion-item').forEach(card => {
    card.style.display = card.getAttribute('data-cat') === categoria ? 'block' : 'none';
  });
  f_track('path_selected', { category: categoria });
  if(!isLoad) f_saveState();
}

function f_toggleOption(el) { 
  const isSelected = el.classList.contains('selected');
  const currentCount = document.querySelectorAll('.f-opcion-item.selected').length;
  
  if (!isSelected && currentCount >= 4) {
    f_showLimitModal();
    return;
  }

  if (!isSelected) { 
    const prods = el.getAttribute('data-prods').split(',');
    prods.forEach(h => removedProds.delete(h));
  }

  el.classList.toggle('selected'); 
  f_updateBar(); 
  f_saveState();
}

function f_updateBar() {
  const selected = document.querySelectorAll('.f-opcion-item.selected');
  document.getElementById('f-count').innerText = selected.length;
  document.getElementById('f-btn-next').disabled = selected.length === 0;
  activeProds.clear();
  selected.forEach(card => {
    const handles = card.getAttribute('data-prods').split(',');
    handles.forEach(h => { 
      if(h && !removedProds.has(h)) activeProds.add(h); 
    });
  });
}

function f_removeTag(title) {
  document.querySelectorAll('.f-opcion-item').forEach(card => {
    if (card.querySelector('.f-opt-title').innerText.trim() === title) {
      card.classList.remove('selected');
    }
  });
  f_updateBar();
  if (activeProds.size === 0) {
    f_backToStep2();
  } else {
    f_goToStep3(true); 
  }
}

function f_copyCoupon() {
  if(!currentActiveDiscountCode) return;
  navigator.clipboard.writeText(currentActiveDiscountCode).then(() => {
    const btn = document.getElementById('f-btn-copy');
    btn.innerText = '¡COPIADO!';
    btn.style.background = '#111';
    setTimeout(() => {
      btn.innerText = 'COPIAR';
      btn.style.background = '#5FB4AA';
    }, 2000);
  });
}

function f_goToStep3(isLoad = false) {
  document.querySelectorAll('.fungi-step').forEach(el => el.classList.remove('active'));
  document.getElementById('f-step-3').classList.add('active');
  
  document.querySelectorAll('.f-prod-wrapper').forEach(wrapper => {
    wrapper.style.display = 'none';
    wrapper.classList.remove('active');
  });

  const container = document.getElementById('f-results-container');
  const wrappers = Array.from(container.querySelectorAll('.f-prod-wrapper'));

  function parseTime(t) {
    if (!t) return 99;
    const clean = t.trim().toLowerCase();
    const match24 = clean.match(/^(\d{1,2})(?::\d{2})?$/);
    if (match24) {
      const h = parseInt(match24[1]);
      return (h >= 0 && h <= 23) ? h : 99;
    }
    const match12 = clean.match(/^(\d{1,2})(?::\d{2})?\s*(am|pm)$/);
    if (match12) {
      let h = parseInt(match12[1]);
      const period = match12[2];
      if (period === 'pm' && h !== 12) h += 12;
      if (period === 'am' && h === 12) h = 0;
      return (h >= 0 && h <= 23) ? h : 99;
    }
    return 99;
  }

  wrappers.sort((a, b) => {
    const timeA = a.querySelector('.f-rec-time') ? a.querySelector('.f-rec-time').innerText : "";
    const timeB = b.querySelector('.f-rec-time') ? b.querySelector('.f-rec-time').innerText : "";
    return parseTime(timeA) - parseTime(timeB);
  });

  wrappers.forEach(w => container.appendChild(w));
  
  activeProds.forEach(handle => {
    const prodEl = document.querySelector(`.f-prod-result[data-handle="${handle}"]`);
    if(prodEl) {
      prodEl.style.display = 'block';
    }
  });
  
  f_refreshTotals();
  f_renderTags();

  // Envía a GA4 la selección exacta del cliente (Síntomas o Metas)
  if(!isLoad) {
    const selectedText = Array.from(document.querySelectorAll('.f-opcion-item.selected'))
                              .map(el => el.querySelector('.f-opt-title').innerText.trim())
                              .join(', ');
                              
    f_track('quiz_completed', { 
      count: activeProds.size,
      selected_options: selectedText
    });
    // Llevamos al cliente suavemente al inicio del recomendador, con un margen de 80px (por si tienes un header fijo)
    const quizContainer = document.getElementById('FungiQuizFlow');
    if (quizContainer) {
      const yOffset = quizContainer.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }
  
  f_saveState();
}

function f_backToStep2() {
  document.querySelectorAll('.fungi-step').forEach(el => el.classList.remove('active'));
  document.getElementById('f-step-2').classList.add('active');
  f_saveState();
}

function f_toggleDetailsRow(el) {
  const wrapper = el.closest('.f-prod-wrapper');
  const btn = wrapper.querySelector('.f-toggle-btn');
  const isOpen = wrapper.classList.contains('active');
  
  document.querySelectorAll('.f-prod-wrapper.active').forEach(w => {
    w.classList.remove('active');
    const b = w.querySelector('.f-toggle-btn');
    if(b) b.classList.remove('is-open');
  });
  
  if (!isOpen) { 
    wrapper.classList.add('active'); 
    if(btn) btn.classList.add('is-open'); 
  }
}

function f_renderTags() {
  const tagsContainer = document.getElementById('f-selected-tags-container');
  tagsContainer.innerHTML = '';
  
  document.querySelectorAll('.f-opcion-item.selected').forEach(card => {
    const iconHTML = card.querySelector('.f-opt-icon').innerHTML;
    const titleText = card.querySelector('.f-opt-title').innerText.trim();
    
    const tagEl = document.createElement('div');
    tagEl.className = 'f-summary-tag';
    tagEl.innerHTML = `<span>${iconHTML}</span> ${titleText}`;
    
    const removeBtn = document.createElement('div');
    removeBtn.className = 'f-remove-tag';
    removeBtn.dataset.title = titleText; 
    removeBtn.textContent = '×';
    tagEl.appendChild(removeBtn);
    
    tagsContainer.appendChild(tagEl);
  });
}

function f_removeProduct(handle) {
  removedProds.add(handle); 
  activeProds.delete(handle); 
  
  document.querySelectorAll('.f-opcion-item.selected').forEach(card => {
    const prods = card.getAttribute('data-prods').split(',');
    if (prods.includes(handle)) {
      const stillActive = prods.some(p => p && activeProds.has(p));
      if (!stillActive) card.classList.remove('selected');
    }
  });
  
  const wrapper = document.querySelector(`.f-prod-result[data-handle="${handle}"]`);
  if (wrapper) wrapper.style.display = 'none';

  f_updateBar(); 

  if (activeProds.size === 0) {
    f_backToStep2();
    return;
  }
  
  f_refreshTotals();
  f_renderTags();
  f_saveState();
}

function f_refreshTotals() {
  let totalPriceCents = 0;
  activeProds.forEach(handle => {
    const prodEl = document.querySelector(`.f-prod-result[data-handle="${handle}"]`);
    if(prodEl) {
      totalPriceCents += parseInt(prodEl.getAttribute('data-price') || 0);
    }
  });

  const step3Top = document.getElementById('f-dynamic-step3-top');
  const activeCount = activeProds.size;
  const extractText = activeCount === 1 ? '1 EXTRACTO' : `${activeCount} EXTRACTOS`;

  if (currentCat === 'cat1') {
    step3Top.innerHTML = `🩺 BASADO EN TUS SÍNTOMAS <span style="margin: 0 5px; opacity: 0.5;">•</span> ${extractText}`;
  } else {
    step3Top.innerHTML = `🎯 BASADO EN TUS OBJETIVOS <span style="margin: 0 5px; opacity: 0.5;">•</span> ${extractText}`;
  }

  let appliedDiscount = null;
  if (activeCount >= 5) appliedDiscount = discountConfig[5];
  else if (activeCount === 4) appliedDiscount = discountConfig[4];
  else if (activeCount === 3) appliedDiscount = discountConfig[3];

  const couponContainer = document.getElementById('f-coupon-container');
  const totalLabel = document.getElementById('f-total-label');
  const priceEl = document.getElementById('f-total-price');
  const originalPriceEl = document.getElementById('f-total-original');
  const savingsEl = document.getElementById('f-savings-text');

  let newTotal = totalPriceCents;

  if (appliedDiscount) {
    currentActiveDiscountCode = appliedDiscount.code;
    let discountAmount = totalPriceCents * appliedDiscount.percent;
    newTotal = totalPriceCents - discountAmount;
    
    document.getElementById('f-coupon-sub').innerText = `CUPÓN BOTIQUÍN COMPLETO — ${appliedDiscount.percent * 100}% OFF`;
    document.getElementById('f-coupon-title').innerText = appliedDiscount.code;
    document.getElementById('f-coupon-desc').innerText = appliedDiscount.text;
    couponContainer.style.display = 'flex';

    totalLabel.innerText = 'TOTAL CON CUPÓN';
    priceEl.innerText = formatMoney(newTotal);
    originalPriceEl.innerText = formatMoney(totalPriceCents);
    originalPriceEl.style.display = 'inline-block';
    savingsEl.innerText = `Ahorro de ${formatMoney(discountAmount)} con cupón ${appliedDiscount.code}`;
    savingsEl.style.display = 'block';
  } else {
    currentActiveDiscountCode = null;
    couponContainer.style.display = 'none';
    totalLabel.innerText = 'TOTAL';
    priceEl.innerText = formatMoney(totalPriceCents);
    originalPriceEl.style.display = 'none';
    savingsEl.style.display = 'none';
  }
  currentTotalCents = newTotal;
}

async function f_addAllToCart() {
  const btn = document.getElementById('f-add-all-btn');
  btn.disabled = true;
  btn.innerText = 'PROCESANDO...';
  btn.classList.add('is-loading'); 
  
  let itemsToAdd = [];
  let outOfStockNames = [];

  activeProds.forEach(handle => {
    const prodEl = document.querySelector(`.f-prod-result[data-handle="${handle}"]`);
    if (prodEl) {
      const title = prodEl.querySelector('.f-item-title').innerText;
      
      const variantSelect = prodEl.querySelector('.f-variant-select');
      const variantId = variantSelect 
        ? parseInt(variantSelect.value) 
        : parseInt(prodEl.getAttribute('data-variant-id'));
      
      const selectedOption = variantSelect?.selectedOptions[0];
      const isVariantAvailable = selectedOption 
        ? !selectedOption.disabled 
        : prodEl.getAttribute('data-available') === 'true';

      if (isVariantAvailable) {
        itemsToAdd.push({ id: variantId, quantity: 1, title: title });
      } else {
        if (selectedOption) {
          const variantLabel = selectedOption.text.split('-')[0].trim();
          outOfStockNames.push(`${title} (${variantLabel})`);
        } else {
          outOfStockNames.push(title); 
        }
      }
    }
  });

  if (itemsToAdd.length === 0 && outOfStockNames.length > 0) {
     f_openModal('f-all-out-modal'); 
     btn.disabled = false;
     btn.innerText = 'AGREGAR AL CARRITO →';
     btn.classList.remove('is-loading');
     return;
  }

  if (outOfStockNames.length > 0) {
    const listEl = document.getElementById('f-out-of-stock-list');
    listEl.innerHTML = outOfStockNames.map(name => `<li>• ${name}</li>`).join('');
    f_openModal('f-stock-modal'); 
    pendingCartItems = itemsToAdd; 
    btn.disabled = false;
    btn.innerText = 'AGREGAR AL CARRITO →';
    btn.classList.remove('is-loading');
    return; 
  }

  f_executeCartAdd(itemsToAdd);
}

let prevFocusedEl = null;

function f_openModal(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;
  
  prevFocusedEl = document.activeElement; 
  modal.classList.add('active');
  
  const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable.length) focusable[0].focus(); 
  
  modal.addEventListener('keydown', f_trapFocus);
}

function f_closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;
  
  modal.classList.remove('active');
  modal.removeEventListener('keydown', f_trapFocus);
  
  if (prevFocusedEl && document.contains(prevFocusedEl) && typeof prevFocusedEl.focus === 'function') {
    prevFocusedEl.focus();
  }
  prevFocusedEl = null;
}

function f_trapFocus(e) {
  if (e.key !== 'Tab') return;
  const modal = e.currentTarget;
  const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable.length === 0) return;
  
  const firstFoc = focusable[0];
  const lastFoc = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === firstFoc) {
    lastFoc.focus(); 
    e.preventDefault();
  } else if (!e.shiftKey && document.activeElement === lastFoc) {
    firstFoc.focus(); 
    e.preventDefault();
  }
}

function f_showLimitModal() { f_openModal('f-limit-modal'); }
function f_closeLimitModal() { f_closeModal('f-limit-modal'); }

function f_showAllOutModal() { f_openModal('f-all-out-modal'); }
function f_closeAllOutModal() { f_closeModal('f-all-out-modal'); }

function f_cancelStockModal() {
  f_closeModal('f-stock-modal');
  pendingCartItems = []; 
}

function f_confirmStockModal() {
  f_closeModal('f-stock-modal');
  if(pendingCartItems.length > 0) f_executeCartAdd(pendingCartItems);
}

async function f_executeCartAdd(items) {
  const btn = document.getElementById('f-add-all-btn');
  btn.disabled = true;
  btn.innerText = 'AGREGANDO...';

  try {
    // Array limpio para Shopify (solo ID y quantity)
    const shopifyItems = items.map(i => ({ id: i.id, quantity: i.quantity }));
    
    const response = await fetch(window.FungiProConfig.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: shopifyItems })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}`);
    }

    localStorage.removeItem('fungi_pro_state');
    
    const finalCount = items.length;
    let finalDiscountCode = null;
    if (finalCount >= 5) finalDiscountCode = discountConfig[5].code;
    else if (finalCount === 4) finalDiscountCode = discountConfig[4].code;
    else if (finalCount === 3) finalDiscountCode = discountConfig[3].code;

    // GA4: Rastreo exacto de lo que se fue al carrito
    f_track('product_added_to_cart', { 
      count: finalCount, 
      discount_applied: !!finalDiscountCode,
      total_value: currentTotalCents,
      items_array: items.map(i => ({ item_id: i.id, item_name: i.title, quantity: i.quantity }))
    });

    if(finalDiscountCode) {
      window.location.href = `/discount/${finalDiscountCode}?redirect=/cart`;
    } else {
      window.location.href = window.FungiProConfig.cartUrl || '/cart';
    }

  } catch (error) {
    console.error('Error al agregar al carrito:', error);
    btn.innerText = 'ERROR - REINTENTAR';
    btn.style.backgroundColor = '#ff4d4d'; 
    btn.disabled = false;
    btn.classList.remove('is-loading'); 
    
    setTimeout(() => {
      btn.innerText = 'AGREGAR AL CARRITO →';
      btn.style.backgroundColor = '';
    }, 3000);
  }
}

f_loadState();

document.addEventListener('click', (e) => {
  if (e.target.closest('.f-modal-box')) {
    if (e.target.closest('.f-btn-close-limit')) f_closeLimitModal();
    if (e.target.closest('.f-btn-close-all-out')) f_closeAllOutModal();
    if (e.target.closest('.f-btn-cancel-stock')) f_cancelStockModal();
    if (e.target.closest('.f-btn-confirm-stock')) f_confirmStockModal();
    return; 
  }

  const overlay = e.target.closest('.f-modal-overlay');
  if (overlay) {
    if (overlay.id === 'f-limit-modal') f_closeLimitModal();
    if (overlay.id === 'f-all-out-modal') f_closeAllOutModal();
    if (overlay.id === 'f-stock-modal') f_cancelStockModal();
    return;
  }

  if (e.target.closest('#f-nav-back') || e.target.closest('#f-nav-cancel') || e.target.closest('#f-nav-restart')) {
    e.preventDefault();
    f_goToStep1();
    return;
  }
  if (e.target.closest('#f-btn-next')) {
    e.preventDefault();
    f_goToStep3();
    return;
  }
  if (e.target.closest('#f-btn-copy')) {
    e.preventDefault();
    f_copyCoupon();
    return;
  }
  if (e.target.closest('#f-add-all-btn')) {
    e.preventDefault();
    f_addAllToCart();
    return;
  }

  const pathCard = e.target.closest('.f-path-trigger');
  if (pathCard) {
    f_goToStep2(pathCard.dataset.category);
    return;
  }

  const optCard = e.target.closest('.f-opt-trigger');
  if (optCard) {
    f_toggleOption(optCard);
    optCard.setAttribute('aria-checked', optCard.classList.contains('selected'));
    return;
  }

  const removeTagBtn = e.target.closest('.f-remove-tag');
  if (removeTagBtn) {
    e.preventDefault();
    f_removeTag(removeTagBtn.dataset.title);
    return;
  }

  const removeProdBtn = e.target.closest('.f-remove-prod-btn');
  if (removeProdBtn) {
    e.preventDefault();
    f_removeProduct(removeProdBtn.dataset.handle);
    return;
  }

  const resultItem = e.target.closest('.f-result-item');
  if (resultItem) {
    f_toggleDetailsRow(resultItem);
    return;
  }
});

function parseCLPPrice(priceText) {
  const clean = priceText.replace(/[$\s]/g, '');
  const withoutThousands = clean.replace(/\./g, '');
  return parseInt(withoutThousands) * 100;
}

document.addEventListener('change', (e) => {
  if (e.target.classList.contains('f-variant-select')) {
    const selectedOption = e.target.selectedOptions[0];
    const priceText = selectedOption.text.split('-').pop().replace('(Agotado)', '').trim();
    
    const form = e.target.closest('form');
    const buyBtn = form?.querySelector('.f-btn-solid');
    if (buyBtn && !selectedOption.disabled) {
      buyBtn.innerHTML = `COMPRAR ${priceText} →`;
    }
    
    const wrapper = e.target.closest('.f-prod-wrapper');
    if (wrapper && !selectedOption.disabled) {
      wrapper.dataset.price = parseCLPPrice(priceText);
      f_refreshTotals();
    }
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    const pathCard = e.target.closest('.f-path-trigger');
    if (pathCard) { 
      e.preventDefault(); 
      f_goToStep2(pathCard.dataset.category); 
    }
    const optCard = e.target.closest('.f-opt-trigger');
    if (optCard) { 
      e.preventDefault(); 
      f_toggleOption(optCard); 
      optCard.setAttribute('aria-checked', optCard.classList.contains('selected'));
    }
  }
});